/**
 * TestOps Command auth store.
 *
 * Same SSO pattern as Athena/Toucan: identity service issues the JWT, this
 * store reads it back and exposes the current user.
 */
import { createProductAuthStore } from '@ytest/auth-client'
import type { User } from '../services/auth'

const config = {
  ytestUrl: import.meta.env.VITE_YTEST_URL || 'https://ytest.ai',
  identityApiUrl: import.meta.env.VITE_IDENTITY_API_URL || 'https://api.ytest.ai',
}

export const useAuthStore = createProductAuthStore<User>(config)
